'use client';

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export const SquareSkeleton: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        paddingTop: '100%'
      }}
    >
      <Skeleton
        variant="rounded"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%'
        }}
      />
    </Box>
  );
};
